<template>
  <div class="content profile">
    <div id="cover" style="background-image: url(/static/img/cover.jpg);">
      <div class="cover">
        <h1>{{$t('profile.info.personalSpace')}}</h1>
      </div>
      <div class="gradientslider"></div>
    </div>
    <div class="container profile-content">
      <div class="page">
        <ul class="nav-menu">
          <router-link tag="li" class="nav-link"
                       :to="{name: 'profile'}" :class="{active: $route.name === 'profile'}">
            <span>Mon compte</span>
          </router-link>
          <router-link tag="li" class="nav-link"
                       :to="{name: 'profile-data'}" :class="{active: $route.name === 'profile-data'}">
            <span>Mes données personnelles</span>
          </router-link>
          <router-link tag="li" class="nav-link" :to="{name: 'privacy'}">
            <span>Espace RGPD</span>
          </router-link>
        </ul>
        <div class="nav-container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'profile'
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/client/profile.vue